import Loading from 'atoms/Loading'
import { Suspense } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { InstallationDashboard } from './InstallationDashboard'
import InstallationDetailPage from './InstallationDetailPage'

export default function InstallationsIndex() {
  const { path } = useRouteMatch()

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={path}>
          <InstallationDashboard />
        </Route>
        <Route path={`${path}/:id`} exact>
          <InstallationDetailPage />
        </Route>
      </Switch>
    </Suspense>
  )
}
